import type { NotificationItemComponent } from "./NotificationItem";

import React, { useMemo, useState } from "react";
import { Typography, Button, Box } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import NotificationItem from "./NotificationItem";

import useProxyList from "@/hooks/useProxyList";
import SimpleModal from "@/components/modals/SimpleModal";
import CodeExample from "@/components/CodeExample/CodeExample";
import { toPlanId } from "@/utils/toPlanId";

const ReminderToUseProxyNotification: NotificationItemComponent = ({
  item,
}) => {
  const [exampleCodeOpen, setExampleCodeOpen] = useState(false);

  const query = {
    page: 1,
    mode: "direct",
    page_size: 1,
    plan_id: toPlanId(item.context?.plan || "default"),
  };

  const { data: proxyListResponse } = useProxyList(query, {
    enabled: true,
  });

  const firstProxyListItem = useMemo(() => {
    if (!proxyListResponse?.results) return;
    return proxyListResponse.results[0];
  }, [proxyListResponse]);

  return (
    <NotificationItem variant={!item.dismissed_at ? "info" : "default"}>
      <NotificationItem.Title created_at={item.created_at}>
        <span>{`It seems like you haven't used your proxies yet`}</span>
      </NotificationItem.Title>
      <NotificationItem.Content>
        <Typography variant="body2">
          You can try one of the code examples to get started.
        </Typography>
      </NotificationItem.Content>
      <NotificationItem.Actions {...item}>
        <Button
          size="small"
          variant={!item.dismissed_at ? "contained" : "outlined"}
          color="primary"
          disableElevation
          endIcon={<OpenInNewIcon fontSize="small" />}
          onClick={(e) => {
            e.stopPropagation();
            setExampleCodeOpen(true);
          }}
        >
          <span>See code examples</span>
        </Button>
      </NotificationItem.Actions>
      <Box onClick={(e) => e.stopPropagation()}>
        <SimpleModal
          open={!!exampleCodeOpen}
          setOpen={setExampleCodeOpen}
          fullWidth
          title={
            <>
              <Typography variant="h6">Configuration Examples</Typography>
              <Typography variant="body1">
                You can use traditional HTTP proxy protocol to access to the
                service.
              </Typography>
            </>
          }
        >
          {firstProxyListItem?.username &&
          firstProxyListItem?.password &&
          firstProxyListItem?.proxy_address &&
          firstProxyListItem?.port ? (
            <CodeExample
              authenticationMethod={"username_password"}
              protocol={"http"}
              proxyUserName={firstProxyListItem?.username}
              password={firstProxyListItem?.password}
              domainName={firstProxyListItem?.proxy_address}
              port={firstProxyListItem?.port.toString()}
              theme="dark"
            />
          ) : null}
        </SimpleModal>
      </Box>
    </NotificationItem>
  );
};

export default ReminderToUseProxyNotification;
